import React, { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function ValidaUrlReact() {
  const query = useQuery();
  const hash = query.get('hash') || sessionStorage.getItem('sessionHash');
  const token = query.get('token') || sessionStorage.getItem('sessionToken');
  const ambiente = query.get('ambiente');

  const navigate = useNavigate();

  const validacaoCpf = sessionStorage.getItem("validacaoCpfOk") === "true";

  useEffect(() => {
    const decodeHashUrl = async () => {
      try {
        sessionStorage.clear();
        const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/session`, {
          method: 'GET',
          headers: {
            'x-Hash': hash,
            'x-Token': token,
            'x-Versao': '2.1.0'
          }
        });
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.retorno || 'Sessão inválida.');
        }

        const dados = data.retorno[0];

        // docs pendentes (recebido = 'N')
        let hasDocsPendentes = false;

        if (dados.outDocsCaptura) {
          try {
            const docsCaptura = JSON.parse(dados.outDocsCaptura);
            hasDocsPendentes = Array.isArray(docsCaptura)
              && docsCaptura.some(d => d.recebido === 'N');
          } catch (e) {
            console.error('Erro ao fazer parse de outDocsCaptura', e);
          }
        }


        if(data.erros === false){
          sessionStorage.setItem('sessionTokenBearer', data.bearer);
          sessionStorage.setItem('sessionToken', token);
          sessionStorage.setItem('sessionHash', hash);
          sessionStorage.setItem('ambienteOrigem', ambiente);
          sessionStorage.setItem('dadosLinkAtual', JSON.stringify(data.retorno[0]));
          
          const dados = data.retorno[0];

          window.clarity("identify", dados.outProtocolo+'_'+dados.outLkcId);
          window.clarity("set", "sessionId", dados.outProtocolo);
          window.clarity("set", "linkId", dados.outLkcId);
          window.clarity("set", "fluxo", "liveness");
          window.clarity("set", "versao_app", "2.1.0");
          window.clarity("set", "aplicacao", sessionStorage.getItem('ambienteOrigem') || 'externo');
          window.clarity("set", "servico", dados.outServico);
          window.clarity("set", "user", dados.outDocumento);

          if(dados.outTipoDocumento){
            sessionStorage.setItem('tipoDoc', ['cnh_new', 'cnh'].includes(dados.outTipoDocumento) ? 'habilitado' : 'naoHabilitado');
          }
          
          if(!validacaoCpf){
            navigate('/confirmacao');
          }
          else if(dados.outStatus === 'C'){
            navigate('/finalizado');
          }
          else if(dados.outStatus === 'F'){
            navigate('/sucesso');
          }
          else if (dados.outArquivo === 'S' && dados.outServico === 'IDD' && hasDocsPendentes) {
            navigate('/documentos-idd');
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'N'){
            navigate("/face");
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'N' && dados.outServico === 'KYC' && dados.outCpr === 'N'){
            navigate("/comprovante-residencia");
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'N' && dados.outServico === 'KYC' && dados.outCpr === 'S'){
            navigate("/face");
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'S' && ['N', 'V', 'C'].includes(dados.outValidacaoBancaria) && dados.outValidacaoPix === 'S' && !(['cnh_new', 'cnh'].includes(dados.outTipoDocumento))){
            navigate("/validaid");
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'S' && dados.outValidacaoBancaria === 'S' && dados.outValidacaoPix === 'S'){
            navigate("/sucesso");
          }
          else if(dados.outArquivo === 'S' && dados.outLiveness === 'S' && dados.outValidacaoPix === 'N'){
            navigate("/sucesso");
          }
          else if(dados.outNomeArquivo && dados.outArquivo === 'N'){
            navigate("/atd-document");
          }
          else{
            navigate("/document");
          }
        }
        else if(data.retorno === 'Versao invalida.'){
          navigate('/versao');
        }
        else{
          sessionStorage.setItem('erroMensagem', data.retorno || 'Erro ao criar sessão.');
          navigate('/erro');
        }
      } catch (err) {
        sessionStorage.setItem('erroMensagem', err?.message || 'Erro ao criar sessão.');
        navigate('/erro');
      }
    };

    if (hash && token) {
      decodeHashUrl();
    }
  }, [hash, token, ambiente, navigate, validacaoCpf]);

  return (
    <div className='content'>
      <div className='content-loading'>
        <span className="loader"></span>
        <p className='text-load'>Configurando o ambiente de verificação.</p>
        <p className='subtext-load'>Carregando suas informações e realizando as validações necessárias. Não feche a tela, estamos quase lá.</p>
      </div>
    </div>
  );
}